// context/PatrolReportContext.js
import React, { createContext, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types'; // Import PropTypes
import { useForm } from 'react-hook-form';

const PatrolReportContext = createContext();

// Custom hook to use the context
export const usePatrolReportContext = () => useContext(PatrolReportContext);

// Provider component to wrap around the app or component tree
export const PatrolReportProvider = ({ children }) => {
  // Manage the state here
  const [patrolReport, setPatrolReport] = useState([]);
  // Drawer open/close state
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  // State for toggling each location image independently
  const [expandedLocation, setExpandedLocation] = useState([false, false]);
  // React hook form setup
  const { control, handleSubmit, reset, setValue, getValues } = useForm({
    mode: 'onBlur',
    defaultValues: {
      title: '',
      startTime: null,
      details: '',
    },
  });

  // Memoize the value to prevent re-creating the object on each render
  const value = useMemo(
    () => ({
      patrolReport,
      setPatrolReport,
      drawerOpen,
      setDrawerOpen,
      loading,
      setLoading,
      control,
      handleSubmit,
      reset,
      setValue,
      getValues,
      expandedLocation,
      setExpandedLocation,
    }),
    [
      patrolReport,
      drawerOpen,
      loading,
      handleSubmit,
      control,
      reset,
      setValue,
      getValues,
      expandedLocation,
    ],
  );

  // Provide the state and setter functions via context
  return <PatrolReportContext.Provider value={value}>{children}</PatrolReportContext.Provider>;
};

// Add prop types validation for children
PatrolReportProvider.propTypes = {
  children: PropTypes.node.isRequired, // Validate children prop
};

export default PatrolReportContext;
